import { BrandVariants, createLightTheme, createDarkTheme, Theme, shorthands } from "@fluentui/react-components";

// NEW THEME
const newTheme: BrandVariants = { 10: "#020404", 20: "#101B1C", 30: "#152D2F", 40: "#173A3D", 50: "#19484C", 60: "#1A565B", 70: "#1A656B", 80: "#03A0AB", 90: "#15838C", 100: "#0E939D", 110: "#18A2AD", 120: "#4DAFB8", 130: "#6FBCC3", 140: "#8DC9CE", 150: "#A9D6DA", 160: "#C4E2E5" };

export const newLightTheme: Theme = { ...createLightTheme(newTheme) };
newLightTheme.colorNeutralBackground1 = "#FCF8F2";

export const dashboardTheme: Theme = { ...createLightTheme(newTheme) };
// NEW THEME

export const newBackground = { backgroundColor: "#FCF8F2" };

// THEMES: To implement Themes all over the app
export const apptheme: BrandVariants = { 10: "#010404", 20: "#0F1A1D", 30: "#142B32", 40: "#163842", 50: "#164652", 60: "#165464", 70: "#136275", 80: "#0C7187", 90: "#038099", 100: "#388DA4", 110: "#D6D6D6", 120: "#6FA8B9", 130: "#86B5C4", 140: "#9DC3CF", 150: "#B4D1DA", 160: "#CADFE5" };

export const darkTheme: Theme = { ...createDarkTheme(apptheme) };
darkTheme.colorNeutralBackground1 = "#E9E9E9";
darkTheme.colorNeutralForeground1 = "#FFFF00";

export const lightTheme: Theme = { ...createLightTheme(apptheme) };
lightTheme.colorNeutralBackground1 = "#f9e5da"; 
lightTheme.colorNeutralBackground4 = "#0A0A0A";

export const breadcrumbTheme: Theme = { ...createLightTheme(apptheme) };
breadcrumbTheme.colorNeutralForeground2 = "#03A0AB";

export const messageTheme: Theme = { ...createLightTheme(apptheme) };
messageTheme.colorNeutralBackground1 = "#EBF3FC";

export const warningTheme: Theme = { ...createLightTheme(apptheme) };
warningTheme.colorNeutralForeground1 = "#C50F1F";

export const mildTheme: Theme = { ...createLightTheme(apptheme) };
mildTheme.colorNeutralForeground1 = "#008099";

export const sidenavTheme: Theme = { ...createLightTheme(apptheme) };
sidenavTheme.colorNeutralBackground1 = "#fcf8f2";
sidenavTheme.colorNeutralBackground4 = "#0A0A0A";

export const hoverTheme: Theme = { ...createLightTheme(apptheme) };
breadcrumbTheme.colorNeutralForeground4 = "#e4f0f2";

// Repeated Styles within customStyles
export const fixedly: any = { position: 'fixed' };
export const relatively: any = { position: 'relative' };
export const absolutely: any = { position: 'absolute' };
export const sticky: any = { position: 'sticky' };

// APP
// To fix the header on the top
export const appHeader: any = { ...fixedly, width: '100%', top: 0, left: 0, zIndex: 1000 };

// To make the body go behind header when scrolled


// export const appBody: any = { position: 'fixed', top: 'auto', overflowY: 'auto', height: "105vh", WebkitOverflowScrolling: 'touch', scrollbarWidth: 'none', scrollbarColor: 'transparent transparent' };
// export const appBody: any = { ...relatively, top: 0, overflowY: 'auto', height: "95vh", WebkitOverflowScrolling: 'touch', scrollbarWidth: 'none', scrollbarColor: 'transparent transparent' };

export const appBody: any = { height: "100%",width:'100%', overflowY: 'auto', WebkitOverflowScrolling: 'touch', scrollbarWidth: 'none', scrollbarColor: 'transparent transparent' };
// position: 'fixed', top: 'auto', overflowY: 'auto', height: "100%",width:'100%', WebkitOverflowScrolling: 'touch', scrollbarWidth: 'none', scrollbarColor: 'transparent transparent'
// SKELETON
export const skeleton1: any = { width: '40vw' };
export const skeleton2: any = { width: '18vw' };
export const skeleton3: any = { width: '26vw' };
export const skeleton4: any = { width: '10vw' };
export const skeleton5: any = { width: '7vw' };
export const skeleton6: any = { width: '14vw' };
export const skeleton7: any = { width: '91vw' };
export const skeleton8: any = { width: '70vw', height: '60vh' };
export const skeletonDataTable8: any = { width: '', height: '100%' };
export const skeleton9: any = { width: '20vw' };
export const skeleton10: any = { width: '14vw', height: '40vh' };
export const skeleton11: any = { width: '33vw' };
export const skeleton12: any = { width: '100%', height: '6vh'};
export const skeleton14: any = { width: '46vw', height: '60vh' };
export const skeletonQuicklink: any = { width: '34vw'};


// SIGNIN: This helps in positioning
export const backgroundPosition: any = { ...fixedly, right: 0, top: 0, width: "40%", height: "100%"};
export const signinformPosition: any = { ...absolutely, left: 37, top: "1%", width: "27%" };
export const signinLogo: any = { ...fixedly, top: -5, left: -63 };
export const cardRadius: any = {borderRadius: "20px", /*boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",*/ backgroundColor: "white"}
export const confirmCard: any = { borderRadius: "3%", boxShadow: "rgba(14, 30, 37, 0.12) 0px 2px 4px 0px, rgba(14, 30, 37, 0.32) 0px 2px 16px 0px", width: '35vw', top: -50, textAlign: 'center' };
export const responsiveStyles: any = {
  "@media (max-width: 1366px)": {
    backgroundPosition: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      zIndex: -1,
    },
    signinformPosition: {
      // position: "relative",
      // left: "50%",
      // top: "10%",
      // transform: "translateX(-50%)",
      // width: "90%", // Adjust form width to fit smaller screens
    },
  },
};
export const buttonPosition: any = { ...fixedly, right: 10, top: 10, width: "50%", height: "100%" };
export const formPosition: any = { ...absolutely, left: 80, top: "20%", width: "20%" };
export const formPositions: any = { ...absolutely, left: 120, top: "22%", width: "30%" };
export const passwordResetFormPositions: any = { ...absolutely, left: 120, top: "5%", width: "30%" };
export const signinFormPosition: any = { ...fixedly, left: 180, top: "20%", width: "20%" };
export const signFormPosition: any = { ...fixedly, left: 120, top: "22%", width: "20%" };
export const notificationPosition: any = { ...fixedly, left: 45, top: "15%", width: "20%" };
export const signLogo: any = { ...fixedly, top: -10, left: 25 };
export const logoCSS:any= {...sticky,marginTop: '-16px',top: '-16px',zIndex: '2',width: '100%'}
export const verifyotpFormPosition: any = { ...fixedly, left: 80, top: "20%", width: "23%" };
export const activeRow: any = { backgroundColor: "#EBF3FC" };
export const inputFieldCSS={maxWidth:'80%', width:'100%'};
export const DynamicBoxingCSS={width:'100%', height:'100%', 
  // borderTop: '0.5px solid #f3d1bf'
};
export const authStyle: any={width:'100%', height:'100%'};
export const sideImageCSS:any={width: '50%',position: 'fixed',right: 0,bottom: 0,top: 0}
export const DateRanger:any={border:'1px solid #e2e1e1', backgroundColor:'#f9fbfd', width:'85%', padding:'10px', borderRadius:'5px'};
// styles.ts (or the appropriate styles file)
export const dropdownStyle: any = { maxHeight: '40vh', height: '100%', overflowY: 'auto', msOverflowStyle: 'none' };
export const dropdownDataStyle: any = { maxHeight: '40vh', height: '100%', overflowY: 'auto', overflowX: 'hidden', msOverflowStyle: 'none', /*scrollbarWidth: 'none' */ };
// export const switchStyle: any = { display: "flex" , justifyContent : "space-between" };
export const hands:any = { cursor: 'pointer' };
export const inlineSidenavWidth:any = { width: '150px' };

// HOME
export const homeCard: any = { height:'-webkit-fill-available', backgroundColor: "#F3D1BF"};
export const homeCardResponsive: any = { height:'100%', backgroundColor: "#F3D1BF"};
// To add background image
export const homeImage: any = { backgroundColor:"#FDFAF5", backgroundSize: 'cover', /* height: '80vh' */ };
// To set the layout
export const parentHome: any = { height: '100%' };
export const quickLinkHeight: any = { width: "42.5%" };
export const sidebarTheme: any = { borderRight: '1px solid #f3d1bf'};

// To set the cards
// export const childHome: any = { width: '100%' };
export const inlineSideMenu: any = { width: '100%' };
export const childHome: any = { 
  width: "100%", 
  borderRadius: "4px", 
  // border: "1px solid #f3d1bf" 
};
export const cardBorder: any = { 
  width: "100%", 
  borderRadius: "4px",
  boxShadow: "none",
  border: "1px solid #F3D1BF" 
};

// To strech the divider
export const dividerStyle: any = { height: '100%'};
export const dividerWidthStyle: any = { width: '100%' };
export const oveyAlignment: any = { height: '100%' };
export const halfWidth: any = { width: '60%' };
export const fitcontentWidth: any = { width: 'fit-content' };
export const heightResponsive: any = { height: "calc(100% - 34px)" }
export const overlayResponsive: any = { height: "calc(100% - 66px)" }
export const BreadcrumbsBorder: any = { borderBottom: "1px solid #f3d1bf", paddingBottom: "3px" }

export const tenantBorder: any = { 
   borderBottom: "1px solid #f3d1bf",
   borderRadius: "0px", background:"white" }
// export const responsiveHight: any = {height: "calc(100% - 22px)", backgroundColor: "#FCF8F2"}
export const responsiveHight: any = {height: "calc(100% - 25px)" }
export const paddingTop: any = {paddingTop:'4px'}
export const SubSectionResponsive : any = { ...responsiveHight }
export const heightOverlayResponsive: any = {     height: "calc(100% - 58px)" }
export const overlayTableHeight: any = {     height: "calc(100% - 90px)" }
export const overlaysubTableHeight: any = {     height: "calc(100% - 48px)" }

export const wraperStyle: any = {gap:'10px', paddingLeft:'10px' }
export const paddingBottom: any = {paddingBottom:'0px'}
export const buttonDisabled: any = {position:"fixed",bottom: "29px", zIndex: "1000", left:'34px'} 
// ICON COLORS
// export const fullscreenIcon: any = { position: 'fixed', right: 5 };
export const fullscreenIcon: any = { marginTop: "3px", marignRight:"3px"};
export const primaryIcon: any = { primaryFill: "#03A0AB" };
export const IconColor: any = { primaryFill: "#EF5E03" };
export const secondaryIcon: any = { primaryFill: "#BDBDBD" };
export const exitIcon: any = { primaryFill: "#D13438" };
export const deleteIcon: any = { primaryFill: "#D13438" };
export const dialogIcon: any = { primaryFill: "#8A3707" };
export const timezoneInfo: any = {primaryFill: "#03A0AB"} //need to change.

// COMMON STYLE
export const overflowDivider: any = { width: '60vw' };
export const calenderFix: any = { zIndex: 1000 };
export const formOverflowDivider: any = { width: '40vw' };
export const horizontalDivider: any = { width: '11vw' };
export const overflowScroll: any = {
  maxHeight: '100%',
  overflowY: 'auto',
  overflowX: 'hidden',
  scrollbarWidth: 'none',
};
// To let only datatable to scroll
export const dataTableScroll: any = { ...relatively, height: '70vh', width: '65vw' };
export const tableDiv: any = { maxHeight: "100%", overflow: "auto", scrollbarWidth:'none' };
export const tableHead: any = { position: "sticky", top: "0", zIndex: 1, background: "#ffff", boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)" };
export const tableCell: any = { overflowWrap: "anywhere" }
// To allows show overlay below header
export const overlayHeight: any = { marginTop: 40 };
export const buttonContent: any = { justifyContent: 'flex-start', color:'#03A0AB', padding: '0', textAlign: 'left', textDecoration: 'none', marginBottom:'0',display:'flex', ':hover': { textDecoration: 'underline !important' } }; // this will place the data present in the button at beginning
export const buttonContentDummy: any = { justifyContent: 'flex-start', color:'#0078D4', padding: '0', textAlign: 'left', marginBottom:'0',display:'flex', textDecoration: 'none', ':hover': { textDecoration: 'underline' } }; // this will place the data present in the button at beginning
export const emailFormat = { maxWidth: "150px", whiteSpace: "nowrap", overflow: "truncate", textOverflow: "ellipsis" };
export const overlayWidth: any = { width: '480px' };
export const inputsizestyle: any = { width: 250 };
export const primaryWidth: any = { width: 350 };
export const secondaryWidth: any = { width: 200 };
export const accordionMargin: any = { marginLeft: -13 };
export const accordionStyle: any = { marginLeft: '2.5vw' };
export const sideBarInline: any = { width:'260px', borderRight: '1px solid #F3D1BF'};
export const unauthorisedPosition: any = { display: "flex", justifyContent: "center", alignItems: "center", height: "80vh", overflow: "hidden" };

// Dynamic Dialog box 
export const dialogBoxStyles: any = {  maxWidth: "100%", right: "18px",  padding: "10px", borderRadius: "4px", marginTop: "74px",marginRight:'0'};
export const popoverStyles: any = { ...fixedly, left: "500px", width: "63%", height: "11%", padding: "10px", borderRadius: "4px", marginTop: "168px" };
export const toastStyles: any = { marginTop: "10px", right: "-17px", position: "absolute" };
export const messageBarStyle: any = { display: "flex", flexDirection: "column", ...shorthands.gap("10px") };
// To help us to fit the column data alignment.
export const columnDataAlign = { textAlign: 'left', justifyContent: 'flex-start' };
export const sidebarHeight: any = { height: "95vh" };
export const iframeStyle: any = { ...relatively, width: '83vw', height: '85vh', border: '1px solid transparent' };
export const textHover: any = { textDecoration: 'none', rootHovered: 'none' };
// To help to give Semi-transparent white color in the backgorung when dialog box will get open
export const dialogBoxBackStyles: any = { ...fixedly, top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "rgba(255, 255, 255, 0.5)", zIndex: 999, display: "flex", justifyContent: "center", alignItems: "center" };
export const overlayLeftWidth:any={width:'70%'};
export const overlayRightWidth:any={width:'30%'};
// export const toastMessage: any = { position: 'absolute', right: -20, top: 35 };
// export const headerstablestyle: any = { ...fixedly, top: 0, left: 0, width: '100%', zIndex: 1000, backgroundColor: '#1A1818' };
// export const contentStyle: any = { paddingTop: '4rem', zIndex: 1 };
// export const scrollerhide : any = {width: '100%', height: '100%', overflow: 'auto', WebkitOverflowScrolling: 'touch', msOverflowStyle: 'none', scrollbarWidth: 'none',}
// export const HomeHome: any = { height: '94vh' };
export const invisible: any = { visibility: 'hidden' };
export const whites: any = { backgroundColor: "white" };
